import { Help } from '@project-lary/react-material-symbols';
import React from 'react';
import { cn } from '../utils/tailwind-merge';
import { FormControl, FormItem, FormLabel, FormMessage, useFormField } from './form';
import IconTooltip from './icon-tooltip';
import { Input } from './input';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  isOptional?: boolean;
  showError?: boolean;
  unit?: string;
  tooltip?: string;
};

const FormTextField = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, isOptional, children, showError = true, unit, tooltip, ...props }, ref) => {
    const { error } = useFormField();
    return (
      <FormItem className={className}>
        {label && (
          <div className="flex h-5 items-center gap-1">
            <FormLabel isOptional={isOptional ?? props.readOnly}>{label}</FormLabel>
            {tooltip && (
              <IconTooltip Icon={Help} className="size-5">
                {tooltip}
              </IconTooltip>
            )}
          </div>
        )}
        <FormControl>
          {!unit ? (
            <Input
              className={cn(
                {
                  'outline-error-9': !!error,
                },
                'pl-1',
              )}
              {...props}
              ref={ref}
            />
          ) : (
            <div className="relative w-full">
              <Input
                className={cn('w-full rounded-md border border-neutral-alpha-5 p-2', {
                  'outline-error-9': !!error,
                })}
                {...props}
                ref={ref}
              />
              <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center">
                <span className="text-neutral-10">{unit}</span>
              </div>
            </div>
          )}
        </FormControl>
        {children}
        {showError && <FormMessage />}
      </FormItem>
    );
  },
);

FormTextField.displayName = 'FormTextField';

export default FormTextField;
